import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { links } from 'utils/featureToggles'

interface Props {
  tab: AdministrationAllowedPaymentProvidersTab
}

export enum AdministrationAllowedPaymentProvidersTab {
  PSP_MATRIX = 'matrix',
  UNCOVERED_CARD_DEPOSITS = 'uncovered',
}

export const AdministrationAllowedPaymentProvidersNavigation: React.FC<Props> = (props) => {
  const navigate = useNavigate()

  const handleTabClick = (tab: string) => {
    switch (tab) {
      case AdministrationAllowedPaymentProvidersTab.PSP_MATRIX:
        return navigate(links.administrationAllowedPaymentProvidersMatrix.url)

      case AdministrationAllowedPaymentProvidersTab.UNCOVERED_CARD_DEPOSITS:
        return navigate(links.administrationAllowedPaymentProvidersUncovered.url)

      default:
        return navigate(links.administrationAllowedPaymentProvidersMatrix.url)
    }
  }

  return (
    <div>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={AdministrationAllowedPaymentProvidersTab.PSP_MATRIX}>
            PSP Matrix
          </TabsTrigger>

          <TabsTrigger value={AdministrationAllowedPaymentProvidersTab.UNCOVERED_CARD_DEPOSITS}>
            Uncovered Card Deposits
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
